/**
 * Custom scroll behavior for route navigation.
 * Restores scroll position on back/forward, smoothly scrolls to hash anchors
 * with an offset for the sticky header, and scrolls to top on new routes.
 */
import type { RouterConfig } from '@nuxt/schema'

export default {
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    else if (to.hash) {
      return {
        el: to.hash,
        top: 64, // Offset for sticky header height
        behavior: 'smooth',
      }
    }
    else {
      return {
        top: 0,
        behavior: 'smooth',
      }
    }
  },
} satisfies RouterConfig
